import { IconLayer } from '@deck.gl/layers';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GOOGLE } from '@rsos/constants/mapProviders';
import { setHoveredAirAmbulance } from '@rsos/reduxDataStore/src/features/airAmbulance/airAmbulanceSlice';
import { panMapTo } from '@rsos/utils/panMapToCoordinate';
import spriteMapping from '../../assets/calls/sprites-output/sprites-info.json';
import callsSprite from '../../assets/calls/sprites-output/sprites_2x.png';
import layers from '../storeLayers';

const useNonCallsGL = ({ map, overlay, isMapIconDisabled }) => {
  const dispatch = useDispatch();
  const mapProvider = useSelector(state => state.sinatra.ui.mapProvider);

  const selectedAirAmbulance = useSelector(
    state => state.airAmbulance.selectedAirAmbulance,
  );
  const nonCalls = useSelector(state => state.airAmbulance.requests.nonCalls);
  const nonCallsList = Object.keys(nonCalls);

  const LAYER_IDS = {
    NON_CALLS: 'non-calls-default',
  };

  const MARKER_SIZES = {
    sizeScale: 60, // this is the factor to scale the icon.
    sizeMinPixels: 38, // when zoomed out, the max height of the icon.
    sizeMaxPixels: 40, // when zoomed in, the max height of the icon.
  };

  const layerFactories = {
    [LAYER_IDS.NON_CALLS]: data => {
      return new IconLayer({
        id: LAYER_IDS.NON_CALLS,
        data,
        getPosition: d => {
          return [
            parseFloat(nonCalls?.[d]?.body?.location?.longitude),
            parseFloat(nonCalls?.[d]?.body?.location?.latitude),
          ];
        },
        pickable: !isMapIconDisabled,
        autoHighlight: true,
        highlightColor: [255, 255, 255, 60],
        iconAtlas: callsSprite,
        iconMapping: spriteMapping,
        sizeUnits: 'meters',
        ...MARKER_SIZES,
        getIcon: () => 'allcall_marker', // matches entry in iconMapping
        onHover: d => {
          const id = d?.object;
          if (id) {
            dispatch(setHoveredAirAmbulance(id));
          } else {
            dispatch(setHoveredAirAmbulance(null));
          }
        },

        onClick: () => {
          // do nothing
        },
        visible: true,
      });
    },
  };
  useEffect(() => {
    if (overlay && nonCallsList.length) {
      layers.save(layerFactories[LAYER_IDS.NON_CALLS](nonCallsList));
      overlay.setLayers(layers.getAll());

      if (selectedAirAmbulance) {
        panMapTo({
          mapProvider,
          mapInstance: map.mapInstance,
          latitude: parseFloat(selectedAirAmbulance?.body?.location?.latitude),
          longitude: parseFloat(
            selectedAirAmbulance?.body?.location?.longitude,
          ),
          zoom: mapProvider === GOOGLE ? 16 : 18,
        });
      }
    } else if (overlay && !nonCallsList.length) {
      layers.save(layerFactories[LAYER_IDS.NON_CALLS]([]));
      overlay.setLayers(layers.getAll());
    }
    /*
      current implementation has requirement to not change viewport when marker is removed
      add useCenterPoint and uncomment below code to recenter to jurisdiction/call's center when marker is removed
      const center = useCenterPoint();
      map.mapInstance.view.goTo({
        center: [center.longitude, center.latitude],
      });
    */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [overlay, selectedAirAmbulance, isMapIconDisabled, nonCalls]);
};

const NonCallsGL = React.memo(({ map, overlay, isMapIconDisabled }) => {
  useNonCallsGL({ map, overlay, isMapIconDisabled });
  return <></>;
});

export default NonCallsGL;
